// src/components/MessageHistoryTab.tsx
import { Clock } from 'lucide-react';
import { ScrollArea } from "@/components/ui/scroll-area";

interface MessageHistoryItem {
  text: string;
  timestamp: Date;
}

interface MessageHistoryTabProps {
  messageHistory: MessageHistoryItem[];
  onApplyHistoryMessage: (message: string) => void;
}

export function MessageHistoryTab({
  messageHistory,
  onApplyHistoryMessage
}: MessageHistoryTabProps) {
  return (
    <>
      <div className="py-2 px-3 border-b flex justify-between items-center">
        <h4 className="font-medium">Message History</h4>
        <span className="text-xs text-gray-500">{messageHistory.length} items</span>
      </div>
      <ScrollArea className="h-72">
        <div className="py-2">
          {messageHistory.length === 0 ? (
            <div className="px-3 py-4 text-center text-gray-500 text-sm">
              No message history yet
            </div>
          ) : (
            messageHistory.slice().reverse().map((msg, idx) => (
              <div 
                key={idx} 
                className="px-3 py-2 hover:bg-gray-100 cursor-pointer border-b"
                onClick={() => onApplyHistoryMessage(msg.text)}
              >
                <div className="text-sm">{msg.text.length > 60 
                  ? `${msg.text.substring(0, 60)}...` 
                  : msg.text}
                </div>
                <div className="text-xs text-gray-500 flex items-center mt-1">
                  <Clock className="h-3 w-3 mr-1" />
                  {new Date(msg.timestamp).toLocaleTimeString()} 
                  {new Date(msg.timestamp).toLocaleDateString() === new Date().toLocaleDateString() 
                    ? ' (Today)' 
                    : ` (${new Date(msg.timestamp).toLocaleDateString()})`}
                </div>
              </div>
            ))
          )}
        </div>
      </ScrollArea>
    </>
  );
}